import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useRouter } from 'next/router';
import { RefObject, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useDispatch } from 'react-redux';
import { useMobileApp } from '../../../../hooks/useMobileApp';
import { setReactPlayerPip } from '../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
const ReactPlayerPipPopup = () => {
  const reactPlayerPip = useSelector((state) => state.common.reactPlayerPip);
  const reactPlayerRef: RefObject<ReactPlayer> = useRef(null);
  const dispatch = useDispatch();
  const { isAppView } = useMobileApp();
  const [isReady, setIsReady] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const router = useRouter();
  useEffect(() => {
    if (reactPlayerRef.current && isReady && isOpen) {
      reactPlayerRef?.current?.seekTo(reactPlayerPip?.currentTime || 0, 'seconds');
    }
  }, [reactPlayerRef, reactPlayerPip, isReady, isOpen]);

  /* const handleRouteChange = useCallback(() => {
    // dispatch(setReactPlayerPip({ ...reactPlayerPip, currentTime: reactPlayerRef.current?.getCurrentTime() || 0 }));
  }, [reactPlayerPip, reactPlayerRef.current?.getCurrentTime(), isReady]);*/

  /* useEffect(() => {
    if (reactPlayerRef.current?.getCurrentTime()) router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [reactPlayerPip, reactPlayerRef.current?.getCurrentTime()]);*/

  useEffect(() => {
    if (!reactPlayerPip.isOpen) {
      dispatch(setReactPlayerPip({ ...reactPlayerPip, currentTime: reactPlayerRef.current?.getCurrentTime() || 0 }));
    }
    setIsOpen(reactPlayerPip.isOpen);
  }, [reactPlayerPip.isOpen]);

  if (!isOpen) return <></>;
  return (
    <>
      <div className="sticky bottom-0 right-0 w-[600px] h-[300px] m-4 z-[100] hover:opacity-100 group">
        <ReactPlayer
          playsinline={isAppView()}
          {...{ ...reactPlayerPip.props, light: undefined }}
          ref={reactPlayerRef}
          playing={true}
          onReady={() => setIsReady(true)}
          controls
        />
        <p className="transition-all font-bold text-white bg-gray-500 opacity-0 group-hover:opacity-75 absolute top-0 right-0 z-10">
          <IconButton
            style={{ outline: 'none', color: 'white' }}
            onClick={() => {
              dispatch(setReactPlayerPip({ ...reactPlayerPip, currentTime: reactPlayerRef.current?.getCurrentTime() || 0, isOpen: false }));
            }}
            size="large">
            <Close />
          </IconButton>
        </p>
      </div>
    </>
  );
};
export default ReactPlayerPipPopup;
